import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { CircularProgress, styled } from "@mui/material";
import { confirmSignUp } from "../cognito";
import ErrorMessage from "./ErrorMessage.tsx";

//region [[ Styles ]]
const VerifyCodeWidgetView = styled("div")({
  display: "flex",
  gap: 8,
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface VerifyCodeProps {
  onComplete: () => void;
  code?: string;
  username?: string;
  message?: string;
}
//endregion [[ Props ]]
function getParamsFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    code: urlParams.get("code"),
    username: urlParams.get("username"),
  };
}

export const VerifyCodeWidget = ({
  onComplete,
  code,
  username,
  message,
}: VerifyCodeProps) => {
  const [error, setError] = useState("");
  const [verified, setVerified] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [expired, setExpired] = useState(false);

  const handleVerifyActivationCode = useCallback(() => {
    (async () => {
      const paramUrl = getParamsFromUrl();
      try {
        setVerifying(true);
        await confirmSignUp(
          username || paramUrl.username,
          code || paramUrl.code,
        );
        setVerified(true);
        setTimeout(onComplete, 4000);
      } catch (e) {
        if (e["code"] === "ExpiredCodeException") {
          setExpired(true);
          setTimeout(onComplete, 4000);
        } else {
          setError(e["message"] || e);
          setVerifying(false);
        }
      }
    })();
  }, [onComplete, code, username]);

  useEffect(() => handleVerifyActivationCode(), [handleVerifyActivationCode]);

  if (error) {
    return (
      <VerifyCodeWidgetView className={"verify-code-widget"}>
        {message && <div>{message}</div>}
        {error && <ErrorMessage error={error} />}
      </VerifyCodeWidgetView>
    );
  }

  return (
    <VerifyCodeWidgetView className={"verify-code-widget"}>
      {message && <div>{message}</div>}
      {verifying && <CircularProgress />}
      {expired && (
        <div>
          The code is expired. Please login, if needed you will get a new code.
        </div>
      )}
      {!verified && !expired && (
        <div>Hang in there as we verify your email.</div>
      )}
      {verified && (
        <div>
          Thank you for verifying your email. For your security, please login
          now.
        </div>
      )}
    </VerifyCodeWidgetView>
  );
};
